import { Box } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { connect } from "react-redux";
import Loader from "../../../generic-components/loader";
import ManageMySharedCostWithNoPlans from "./manage-my-shared-cost-content/ManageMySharedCostWithNoPlans";
import NewManageMySharedCostWithPlans from "./manage-my-shared-cost-content/NewManageMySharedCostWithPlans";
import usePlan from "../../../../hooks/usePlan";
import usePlanDetails from "../../../../hooks/usePlanDetails";
import { checkActiveSchemes } from "../../../../helpers";
import useStepper from "../../../../hooks/useStepper";
import isEmpty from "lodash.isempty";
import { useNavigate } from "react-router-dom";
import NewSharedHeader from "../../../generic-components/shared-header/NewSharedHeader";

const ManageMySharedCostAVCPage = ({ user }) => {
  const { plans, forcefullyFetchPlans } = usePlan();
  const navigate = useNavigate();
  const { personalDetails } = useStepper();
  const { fetchCompletePlanDetails, isPlanLoading } = usePlanDetails();

  useEffect(() => {
    if (user.id && user.organisation_id && !isEmpty(personalDetails)) {
      const requiredActiveScheme = checkActiveSchemes(personalDetails);
      if (!requiredActiveScheme) navigate("/scheme_not_found");
      fetchCompletePlanDetails(user.id, user.organisation_id, true);
    }
  }, [user.organisation_id, user.id, forcefullyFetchPlans]);

  return (
    <Box className="application-page-container manage-my-shared-cost">
      <NewSharedHeader heading="Manage My AVC" />
      {isPlanLoading ? (
        <Box className="mt-200">
          <Loader />
        </Box>
      ) : plans?.length ? (
        <NewManageMySharedCostWithPlans plans={plans} />
      ) : (
        <>
          <ManageMySharedCostWithNoPlans />
          <Box className="home-detail-section back-img-sm"></Box>
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state?.user?.user,
  };
};

ManageMySharedCostAVCPage.propTypes = {
  user: PropTypes.object,
};

export default connect(mapStateToProps)(ManageMySharedCostAVCPage);
